import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import authService from "../services/discordAuth";

function AuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const [error, setError] = useState("");
  const hasRun = useRef(false); // Previne dupla execução em dev mode

  useEffect(() => {
    // Previne dupla execução no React StrictMode
    if (hasRun.current) return;
    hasRun.current = true;

    const handleCallback = async () => {
      const code = searchParams.get("code");
      const errorParam = searchParams.get("error");

      if (errorParam) {
        setStatus("error");
        setError("Autenticação cancelada ou negada.");
        setTimeout(() => navigate("/"), 3000);
        return;
      }

      if (!code) {
        setStatus("error");
        setError("Código de autenticação não encontrado.");
        setTimeout(() => navigate("/"), 3000);
        return;
      }

      // Troca o código por token
      const success = await authService.exchangeCode(code);

      if (success) {
        setStatus("success");
        // Redireciona e recarrega a página para atualizar o estado
        setTimeout(() => {
          window.location.href = "/";
        }, 2000);
      } else {
        setStatus("error");
        setError("Falha ao autenticar. Tente novamente.");
        setTimeout(() => navigate("/"), 3000);
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="auth-callback-page">
      <div className="auth-callback-container">
        {status === "loading" && (
          <div className="auth-status">
            <div className="spinner"></div>
            <h2>Autenticando...</h2>
            <p>Aguarde enquanto conectamos sua conta Discord</p>
          </div>
        )}

        {status === "success" && (
          <div className="auth-status success">
            <div className="success-icon">✅</div>
            <h2>Autenticação Bem-sucedida!</h2>
            <p>Redirecionando...</p>
          </div>
        )}

        {status === "error" && (
          <div className="auth-status error">
            <div className="error-icon">❌</div>
            <h2>Erro na Autenticação</h2>
            <p>{error}</p>
            <p className="redirect-text">Redirecionando para a página inicial...</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default AuthCallback;
